export default "__VITE_ASSET__DPqvncl$__"